<template>
    <fieldset class="anon-visitor-options">
        <legend>
            {{ $t('anonVisitorRadioButtons.labels.Visitor type') }}
        </legend>
        <div class="anon-visitor-radio-list">
            <pendo-radio-group
                :value="value"
                :disabled="readOnly"
                @change="onChange">
                <div v-pendo-tooltip="disableAnonymousOptionTooltip">
                    <div class="identified-visitors-only">
                        <pendo-radio
                            :disabled="disableAnonymousOption"
                            value="visitorId"
                            :label="$t('anonVisitorRadioButtons.labels.Identified visitors only')" />
                    </div>
                    <div class="anonymous-visitors-only">
                        <pendo-radio
                            :disabled="disableAnonymousOption"
                            value="!visitorId"
                            :label="$t('anonVisitorRadioButtons.labels.Anonymous visitors only')" />
                    </div>
                </div>
                <div class="all-visitors">
                    <pendo-radio
                        :value="null"
                        :label="$t('anonVisitorRadioButtons.labels.All visitors')" />
                </div>
            </pendo-radio-group>
        </div>
    </fieldset>
</template>
<script>
import { PendoTooltip, PendoRadio, PendoRadioGroup } from '@pendo/components';

export default {
    name: 'AnonVisitorRadioOptions',
    components: {
        PendoRadio,
        PendoRadioGroup,
    },
    directives: {
        PendoTooltip,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        disableAnonymousOption: {
            type: Boolean,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['input'],
    computed: {
        disableAnonymousOptionTooltip () {
            return {
                multiline: true,
                content: this.disableAnonymousOption
                    ? this.$t('anonVisitorRadioButtons.Anonymous visitors cannot be included in this segment')
                    : null,
            };
        },
    },
    methods: {
        onChange (value) {
            this.$emit('input', { selectedVisitorType: value });
        },
    },
};
</script>

<style lang="less" scoped>
fieldset {
    border: none;
    padding: 0;
    margin: 0;
}

legend {
    font-size: 14px;
    font-weight: 600;
    border: none;
    margin: 0 0 12px 0;
    color: var(--palette-gray-100);
}
</style>